export const ACTION_GET_PRODUCT_REVIEW = '/ProductReviews/GetProductReviews';